import { Flex } from "@chakra-ui/react"
import React from "react"

type Props = {
  children?: React.ReactNode
  onMouseDown?: React.MouseEventHandler
}

const SuggestionRow = ({ children, onMouseDown }: Props) => {
  return (
    <Flex
      position="relative"
      align="flex-start"
      fontSize="xs"
      fontWeight="normal"
      lineHeight="4"
      cursor="pointer"
      px="2"
      py="4"
      _hover={{ ".suggestion-name": { textDecoration: "underline" } }}
      _first={{ pt: { base: "1", md: "0.5" } }}
      _notLast={{
        _after: {
          content: '""',
          position: "absolute",
          bottom: "0",
          right: "2",
          height: "px",
          width: "calc(100% - 72px)",
          color: "gray.300",
          borderBottom: "1px solid",
        },
      }}
      onMouseDown={onMouseDown}
    >
      {children}
    </Flex>
  )
}

export default SuggestionRow
